import React from 'react';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';
import { ListItemButton, ListItemIcon, ListItemText, useMediaQuery, Collapse, Divider } from '@mui/material';
import { useLocation } from 'react-router-dom';
import routes from '../../../Utils/routes';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import { useStyles } from '../styles';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import { ReactComponent as Events } from '../../../Assets/icons/Events.svg';
import { ReactComponent as AccountCircleOutlinedIcon } from '../../../Assets/icons/MyProfile.svg';
import { ReactComponent as AccountCircleOutlinedIconSelect } from '../../../Assets/icons/MyProfileSelect.svg';
import { ReactComponent as FeedIcon } from '../../../Assets/Events/FeedIcon.svg';
import { ReactComponent as FeedIconActive } from '../../../Assets/Events/FeedIconActive.svg';

import { ReactComponent as EventsSelect } from '../../../Assets/icons/EventsSelect.svg';
import { ReactComponent as Homeicon } from '../../../Assets/homeIconSide.svg';
import { ReactComponent as HomeiconSelect } from '../../../Assets/homeIconSideActive.svg';
import { ReactComponent as Feed } from '../../../Assets/icons/Feed.svg';
import { ReactComponent as FeedSelect } from '../../../Assets/icons/FeedSelect.svg';
import { ReactComponent as Jobs } from '../../../Assets/icons/Job.svg';
import { ReactComponent as JobsSelect } from '../../../Assets/icons/JobSelect.svg';
import { ReactComponent as MentorShip } from '../../../Assets/icons/MentorShip.svg';
import { ReactComponent as MentorShipSelect } from '../../../Assets/icons/MentorShipSelect.svg';
import { ReactComponent as FundRaise } from '../../../Assets/icons/FundRaise.svg';
import { ReactComponent as FundRaiseSelect } from '../../../Assets/icons/FundRaiseSelect.svg';
import { ReactComponent as Networks } from '../../../Assets/icons/Networks.svg';
import { ReactComponent as NetworksSelect } from '../../../Assets/icons/NetworksSelect.svg';
import { ReactComponent as InfoHub } from '../../../Assets/icons/InfoHub.svg';
import { ReactComponent as InfoHubcopy } from '../../../Assets/infoIconSide.svg';
import { ReactComponent as Survey } from '../../../Assets/icons/Survey.svg';
import { ReactComponent as SurveySelect } from '../../../Assets/icons/SurveySelect.svg';
import { ReactComponent as Service } from '../../../Assets/icons/Service.svg';
import { ReactComponent as ServiceSelect } from '../../../Assets/icons/ServiceSelect.svg';

import { ReactComponent as Logout } from '../../../Assets/icons/LogOut.svg';
interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
}

const SideNavTabs: React.FunctionComponent<SideNavProps> = ({ handleListClick }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const getFirstPath = pathname.split('/').filter((items: string) => items && items !== '');
  const is1980 = useMediaQuery('(max-width:1280px)');
  const [openInfoHub, setOpenInfoHub] = React.useState(false);

  const sideNavContents = [
    {
      icon: (isActive: boolean) => (
        isActive
          ? <HomeiconSelect className={classes.listItemIcon} />
          : <Homeicon className={classes.listItemIconActive} />
      ),
      label: 'Home',
      link: routes.home,
      name: 'home',
    },
    {
      icon: (isActive: boolean) => (
        isActive ?
          <AccountCircleOutlinedIconSelect className={isActive ? classes.listItemIconActive : classes.listItemIcon} /> :
          <AccountCircleOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'My Profile',
      link: routes.myProfile,
      name: 'my%20Profile',
    },
    {
      icon: (isActive: boolean) => (
        isActive
          ? <FeedIconActive className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
          : <FeedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'My Feed',
      link: routes.myFeed,
      name: 'my%20Feed',
    },
    {
      icon: (isActive: boolean) => (
        isActive
          ? <EventsSelect className={classes.listItemIcon} />
          : <Events className={classes.listItemIconActive} />
      ),
      label: 'Events',
      link: routes.events,
      name: 'events',
    },
    {
      icon: (isActive: boolean) => (
        isActive
          ? <JobsSelect className={classes.listItemIcon} />
          : <Jobs className={classes.listItemIconActive} />
      ),
      label: 'Jobs',
      link: routes.jobs,
      name: 'jobs',
    },
    {
      icon: (isActive: boolean) => (
        isActive
          ? <MentorShipSelect className={classes.listItemIcon} />
          : <MentorShip className={classes.listItemIconActive} />
      ),
      label: 'Mentorship',
      link: routes.mentorship,
      name: 'mentorship',
    },
    {
      icon: (isActive: boolean) => (
        isActive ?
          <FundRaiseSelect className={isActive ? classes.listItemIconActive : classes.listItemIcon} /> :
          <FundRaise className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Fundraise',
      link: routes.fundraise,
      name: 'fundraise',
    },
    {
      icon: (isActive: boolean) => (
        isActive
          ? <NetworksSelect className={classes.listItemIcon} />
          :
          <Networks className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Network',
      link: routes.network,
      name: 'network',
    },
    {
      icon: (isActive: boolean) => (
        <GroupsOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Groups',
      link: routes.groups,
      name: 'groups',
    },
    {
      icon: (isActive: boolean) => (
        <InfoHubcopy className={classes.listItemIcon} />
      ),
      label: 'Info Hub',
      name: 'infohub',
      isDropdown: true,
      children: [
        {
          label: 'Photos',
          link: routes.photos,
          name: 'photos',
          icon: (isActive: boolean) => (
            <PermMediaOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
          ),
        },
        {
          label: 'Business Directory',
          link: routes.businessdirectory,
          name: 'business%20directory',
          icon: (isActive: boolean) => (
            <ComputerOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
          ),
        },
        {
          label: 'Resources',
          link: routes.resources,
          name: 'resources',
          icon: (isActive: boolean) => (
            <MenuBookIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
          ),
        },
      ],
    },
    {
      icon: (isActive: boolean) => (
        isActive
          ? <SurveySelect className={classes.listItemIcon} />
          : <Survey className={classes.listItemIconActive} />
      ),
      label: 'Survey',
      link: routes.survey,
      name: 'survey',
    },
    // {
    //   icon: (isActive: boolean) => (
    //     isActive
    //       ? <ServiceSelect className={classes.listItemIcon} />
    //       : <Service className={classes.listItemIconActive} />
    //   ),
    //   label: 'Service & Support',
    //   link: routes.service,
    //   name: 'service%20&%20support',
    // },
    {
      icon: (isActive: boolean) => (
        <Logout className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Logout',
      link: routes.login,
      name: 'logout',
    },
  ];
  const isInfoHubActive = sideNavContents
    .find((item: any) => item.isDropdown)
    ?.children?.some((subItem: any) => getFirstPath[0] === subItem.name);

  return (
    <>
      {is1980 ? (
        <div style={{ overflow: 'auto', height: `calc(100vh - 220px)`, marginBottom: '20px' }} className="scrollbar-cusgray">
          {sideNavContents.map((item: any, index) => {
            if (item.isDropdown) {
              return (
                <div key={item.label}>
                  <ListItemButton onClick={() => setOpenInfoHub(!openInfoHub)} className={classes.listItemButton}>
                    {item.icon && (
                      <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>
                        {item.icon(isInfoHubActive)}
                      </ListItemIcon>
                    )}
                    <ListItemText
                      primary={item.label}
                      className={`${classes.listItemText}`}
                    />
                    {openInfoHub ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>

                  <Collapse in={openInfoHub} timeout="auto" unmountOnExit>
                    {item.children.map((subItem: any) => {
                      const isSubItemActive = getFirstPath[0] === subItem.name;
                      return (
                        <ListItemButton
                          key={subItem.label}
                          onClick={() => handleListClick(subItem.link, index)}
                          className={`${classes.listItemButton} ${isSubItemActive && classes.listItemButtonActive}`}
                          sx={{ pl: 4 }}
                        >
                          {subItem.icon && (
                            <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>
                              {subItem.icon(isSubItemActive)} {/* Render subheading icon */}
                            </ListItemIcon>
                          )}
                          <ListItemText
                            primary={subItem.label}
                            className={`${classes.listItemText} ${isSubItemActive && classes.listItemTextActive}`}
                          />
                        </ListItemButton>
                      );
                    })}
                  </Collapse>
                </div>
              );
            } else {
              return (
                <ListItemButton
                  key={item.label}
                  onClick={() => handleListClick(item.link, index)}
                  className={`${classes.listItemButton} ${getFirstPath[0] === item.name && classes.listItemButtonActive}`}
                >
                  <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>
                    {item.icon && item.icon(getFirstPath[0] === item.name)}
                  </ListItemIcon>
                  <ListItemText
                    primary={item?.label}
                    primaryTypographyProps={{
                      sx: {
                        fontSize: getFirstPath[0] === item.name ? '12px' : '12px',
                        fontWeight: getFirstPath[0] === item.name ? 'bold' : 400,
                        color: getFirstPath[0] === item.name ? '#373A45' : '#373A45',
                        '@media (min-width: 1280px) and (max-width: 1300px)': {
                          fontSize: '10px',
                        },
                      },
                    }}
                  />

                </ListItemButton>
              );
            }
          })}
        </div>
      ) : (
        <>
          <div style={{ overflow: 'auto', height: 'calc(100vh - 280px)' }} className="scrollbar-cusgray">
            {sideNavContents.slice(0, -1).map((item: any, index) => {
              if (item.isDropdown) {
                return (
                  <div key={item.label}>
                    <ListItemButton  onClick={() => setOpenInfoHub(!openInfoHub)} className={classes.listItemButton}>
                      {item.icon && (
                        <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>
                          {item.icon(isInfoHubActive)}
                        </ListItemIcon>
                      )}
                      <ListItemText
                        primary={item.label}
                        className={`${classes.listItemText} ${isInfoHubActive && classes.listItemTextActive1}`}
                      />
                      {openInfoHub ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>

                    <Collapse in={openInfoHub} timeout="auto" unmountOnExit>
                      {item.children.map((subItem: any) => {
                        const isSubItemActive = getFirstPath[0] === subItem.name;
                        return (
                          <ListItemButton
                            key={subItem.label}
                            onClick={() => handleListClick(subItem.link, index)}
                            className={`${classes.listItemButton} ${isSubItemActive && classes.listItemButtonActive}`}
                            sx={{ pl: 4 }}
                          >
                            {subItem.icon && (
                              <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>
                                {subItem.icon(isSubItemActive)} {/* Render subheading icon */}
                              </ListItemIcon>
                            )}
                            <ListItemText
                              primary={subItem.label}
                              className={`${classes.listItemText} ${isSubItemActive && classes.listItemTextActive}`}
                            />
                          </ListItemButton>
                        );
                      })}
                    </Collapse>
                  </div>
                );
              } else {
                return (
                  <ListItemButton
                    key={item.label}
                    onClick={() => handleListClick(item.link, index)}
                    className={`${classes.listItemButton} ${getFirstPath[0] === item.name && classes.listItemButtonActive}`}
                  >
                    <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>
                      {item.icon && item.icon(getFirstPath[0] === item.name)}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.label}
                      className={`${classes.listItemText} ${getFirstPath[0] === item.name && classes.listItemTextActive}`}
                    />
                  </ListItemButton>
                );
              }
            })}
          </div>
          <div>
            {/* Logout item */}
            {sideNavContents.slice(-1).map((item: any, index) => (
              <>
                <Divider
                  sx={{
                    height: '0.7px',
                    backgroundColor: '#050917',
                    border: 'none',
                    borderRadius: '2px',
                  }}
                />

                <ListItemButton
                  key={item.label}
                  onClick={() => handleListClick(item.link, index)}
                  style={{
                    marginTop: '0px',
                    // position: 'absolute',
                    // bottom: '10px',
                    marginBottom: '20px',
                    // borderTop : '1px solid '
                  }}
                  className={`${classes.listItemButton} ${getFirstPath[0] === item.name && classes.listItemButtonActive}`}
                >
                  <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>
                    {item.icon && item.icon(getFirstPath[0] === item.name)}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    className={`${classes.listItemText} ${getFirstPath[0] === item.name && classes.listItemTextActive}`}
                  />
                </ListItemButton>
              </>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default SideNavTabs;
